import React from 'react';
import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useStyles } from '../../../styles/mapStylesCustom';
import useTimeStore from '../ZustandProvider';
import LayerEditorMaps from '../LayerEditorMaps';

// import MapaDeck from '../DeckGL/index';
// import BaseMapTable from '../BaseMapTable';
// import LayersTable from '../LayersTable';

import BotonEditor from '../BotonEditor';
import BotonMenu from '../BotonMenu';
import LocationMenu from '../LocationMenu';

import MapContainerSyncMap from '../../containers/MapContainerSyncMap';
import MapContainerViewMap from '../../containers/MapContainerViewMap';
// import MapContainerDeck from '../../containers/MapContainerDeck'; // comment deck
import CesiumViewerContainerViewMap from '../../containers/CesiumViewerContainerViewMap';
import NavBar from '../NavBar';
// import DeckGLContainerViewMap from '../../containers/DeckGLContainerViewMap/index'; // comment deck

let forceUpdateDrawerWidth;
const ManageComponents = props => {
  const {
    arriba,
    arribasize,
    changeLoading,
    centro,
    color,
    componente,
    height,
    id,
    isPublicMap,
    izquierda,
    map,
    MapProps,
    userProps
  } = props;
  const drawerWidth = useTimeStore(state => state.drawerWidth);
  const adjustMap = useTimeStore(state => state.adjustMap);
  const elemento = useTimeStore(state => state.elemento);
  const mapTypeView = useTimeStore(state => state.mapTypeView);
  const save = useTimeStore(state => state.save);

  const [component, setComponent] = React.useState('Nada');
  const [componentToRender, setComponentToRender] = React.useState(<h1>RENDERING</h1>);
  const componenteArray = map.layoutJson.child.findIndex(
    x => x.componente === 'NavBar' || x.componente === 'BotonMenu'
  );
  const existeDrawer = componenteArray !== -1;
  const classes = useStyles();
  const bordercol = id === elemento ? 'red' : 'rgba(0, 0, 0, 0)';
  const borderstl = id === elemento ? 3 : 0;
  const heightOffset = isPublicMap ? 0 : 56;
  const isMobile = window.innerWidth < 500;
  const changeIzquierda = () => {
    let izquierdaLocal = izquierda;
    if (adjustMap === true && component === 'Map' && existeDrawer === true && isMobile === false) {
      if (drawerWidth === 25) {
        izquierdaLocal = 3;
      } else if (drawerWidth === 100 / 3) {
        izquierdaLocal = 4;
      } else if (drawerWidth === 50) {
        izquierdaLocal = 6;
      } else if (drawerWidth === 75) {
        izquierdaLocal = 9;
      }
    } else if (
      component === 'NavBar' &&
      isMobile === false &&
      (drawerWidth >= 50 || mapTypeView === 'mapSync')
    ) {
      izquierdaLocal = 11;
    } else if (component === 'BotonEditor') {
      izquierdaLocal = 11;
    } else if ((component === 'BotonMenu' || component === 'LocationMenu') && isMobile === true) {
      izquierdaLocal = 11;
    }
    return izquierdaLocal;
  };
  const changeWidth = () => {
    let ancho = centro;
    if (adjustMap === true && component === 'Map' && existeDrawer === true && isMobile === false) {
      if (drawerWidth === 25) {
        ancho = 9;
      } else if (drawerWidth === 100 / 3) {
        ancho = 8;
      } else if (drawerWidth === 50) {
        ancho = 6;
      } else if (drawerWidth === 75) {
        ancho = 3;
      }
    } else if (
      component === 'NavBar' &&
      isMobile === true &&
      (drawerWidth >= 50 || mapTypeView === 'mapSync')
    ) {
      ancho = 1;
    } else if (isMobile === true && component === 'BotonEditor') {
      ancho = 1;
    }
    return ancho;
  };

  const changeHeight = () => {
    let altura = height;
    if (component === 'Map') {
      altura = `calc(100vh - ${heightOffset}px)`;
    }
    return altura;
  };
  const changeArribasize = () => {
    let arribasizeLocal = arribasize;

    if (component === 'NavBar' && isMobile === true && drawerWidth >= 50) {
      arribasizeLocal = '10vh';
    }
    return arribasizeLocal;
  };

  const renderComponent = async () => {
    switch (component) {
      case 'Map':
        if (mapTypeView === 'mapSync') {
          setComponentToRender(
            <MapContainerSyncMap
              deployEnv={MapProps.deployEnv}
              height={`calc(${height} - ${heightOffset}px)`}
              history={MapProps.history}
              isFixedHeight
              isFullScreen={false}
              match={MapProps.match}
              popupProp={!MapProps.map.selectedButtons.PopupInformation}
              userControlSetting={MapProps.userControlSetting}
              {...MapProps}
            />
          );
        } else if (mapTypeView === 'map') {
          setComponentToRender(
            <MapContainerViewMap
              externalBoton
              forceUpdateDrawerWidth={forceUpdateDrawerWidth}
              height={`calc(${height} - ${heightOffset}px)`}
              isFixedHeight
              isFullScreen={false}
              isPublicMap={isPublicMap}
              popupProp={!MapProps.map.selectedButtons.PopupInformation}
              width="100%"
              userControlSetting={MapProps.userControlSetting}
              {...MapProps}
            />
          );
        } else if (mapTypeView === 'map3D') {
          setComponentToRender(
            <CesiumViewerContainerViewMap
              baseMaps={MapProps.baseMaps}
              height={`calc(${height} - ${heightOffset}px)`}
              isFixedHeight
              isAtlas={false}
              isFullScreen={false}
              layers={MapProps.layers}
              map={map}
              userControlSetting={MapProps.userControlSetting}
            />
          );
          // } else if (mapTypeView === 'mapDeckGL') {
          //   setComponentToRender(
          //     <DeckGLContainerViewMap
          //       baseMaps={MapProps.baseMaps}
          //       layers={MapProps.layers}
          //       mapLocation={map.mapLocation}
          //     />
          //   );
        }
        break;
      // case 'BaseMap':
      //   setComponentToRender(<BaseMapTable />);
      //   break;
      case 'NavBar':
        setComponentToRender(
          <NavBar
            changeLoading={changeLoading}
            isMobile={isMobile}
            isPublicMap={isPublicMap}
            map={map}
            MapProps={MapProps}
          />
        );
        break;
      case 'BotonMenu':
        setComponentToRender(
          <BotonMenu
            changeLoading={changeLoading}
            isMobile={isMobile}
            isPublicMap={isPublicMap}
            map={map}
            MapProps={MapProps}
            userProps={userProps}
          />
        );
        break;
      case 'LocationMenu':
        setComponentToRender(
          <LocationMenu
            isMobile={isMobile}
            isPublicMap={isPublicMap}
            map={map}
            MapProps={MapProps}
            userProps={userProps}
          />
        );
        break;
      case 'BotonEditor':
        setComponentToRender(<BotonEditor isPublicMap={isPublicMap} map={map} {...MapProps} />);
        break;
      case 'LayersControl':
        setComponentToRender(<LayerEditorMaps />);
        break;
      case 'Nada':
        setComponentToRender('');
        break;
      default:
        setComponentToRender(<p />);
    }
  };

  React.useEffect(() => {
    setComponent(componente);
    renderComponent();
  }, [component, props, mapTypeView, save]);

  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={0} direction="row">
          <Grid item xs={arriba}>
            <Box className={classes.alca} height={changeArribasize()} />
          </Grid>
          <Grid item xs={changeIzquierda()}>
            <Box className={classes.alca} height="0px" maxHeight={height} />
          </Grid>
          <Grid item xs={changeWidth()}>
            <Box
              className={classes[color]}
              border={borderstl}
              borderColor={bordercol}
              height={changeHeight()}
              width={
                component === 'Map' && adjustMap === true && isMobile === false
                  ? `calc(100vw - ${drawerWidth}vw )`
                  : '100%'
              }
            >
              {componentToRender}
            </Box>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

ManageComponents.defaultProps = {
  arriba: 1,
  arribasize: '',
  centro: 1,
  changeLoading: () => {},
  color: '',
  componente: '',
  height: '',
  id: '',
  isLast: false,
  isPublicMap: false,
  izquierda: 1,
  map: {},
  MapProps: {},
  name: '',
  userProps: {}
};

ManageComponents.propTypes = {
  arriba: PropTypes.number,
  arribasize: PropTypes.string,
  centro: PropTypes.number,
  changeLoading: PropTypes.func,
  color: PropTypes.string,
  componente: PropTypes.string,
  height: PropTypes.string,
  id: PropTypes.string,
  isLast: PropTypes.bool,
  isPublicMap: PropTypes.bool,
  izquierda: PropTypes.number,
  map: PropTypes.object,
  MapProps: PropTypes.object,
  name: PropTypes.string,
  userProps: PropTypes.object
};

export default ManageComponents;
